import { WatchQueryFetchPolicy, ErrorLike } from '@apollo/client';
import { TaskCompletion, useTaskCompletionQuery } from '@lib/graphql-common';

type Args = {
  id: string;
  isViewLocked?: boolean;
  skip?: boolean;
  fetchPolicy?: WatchQueryFetchPolicy;
};

export type UseTaskCompletionQueryHookResult = {
  data: TaskCompletion | null | undefined;
  error: ErrorLike | undefined;
  firstLoading: boolean;
  loading: boolean;
  refetch: () => Promise<unknown>;
};

export default function useTaskCompletionQueryHook(
  args: Args,
): UseTaskCompletionQueryHookResult {
  const {
    id,
    isViewLocked = false,
    skip,
    fetchPolicy = 'cache-and-network',
  } = args;
  const query = useTaskCompletionQuery({
    skip: !id || skip,
    variables: {
      id,
      isViewLocked,
    },
    fetchPolicy,
  });
  const { data: queryData, refetch, loading, error, previousData } = query;
  const data = queryData || previousData;
  const taskCompletionData = data?.data as TaskCompletion;
  const firstLoading = loading && queryData === undefined;

  return {
    data: taskCompletionData,
    error,
    firstLoading,
    loading,
    refetch,
  };
}
